<template>
  <v-card flat tile>
    <v-card-title>
      <span class="headline">Sign In</span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-text-field
              label="Email*"
              v-model="email"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="password"
              label="Password*"
              type="password"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
      <small>*indicates required field</small>
    </v-card-text>
    <v-img style="width:5rem;" src="@/assets/google.svg"> </v-img>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="emitDialogClosed">Close</v-btn>
      <v-btn x-large color="primary" type="submit" @click.prevent="signIn()"
        >Sign In</v-btn
      >
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  name: "SignIn",
  data: () => ({
    email: "",
    password: "",
    token: null,
    user: null
  }),
  methods: {
    emitDialogClosed() {
      this.$emit("dialog-closed", false);
    },
    signIn() {
      const user = {
        email: this.email,
        password: this.password
      };
      this.$store.dispatch("signInAction", user);
    }
    // googleSignIn() {
    //   var provider = new fb.auth.GoogleAuthProvider();
    //   provider.addScope("https://www.googleapis.com/auth/contacts.readonly");
    //   fb.auth().languageCode = "pt";
    //   // To apply the default browser preference instead of explicitly setting it.
    //   // fb.auth().useDeviceLanguage();
    //   provider.setCustomParameters({
    //     login_hint: "user@example.com"
    //   });
    //   fb.auth().signInWithRedirect(provider);
    //   fb.auth()
    //     .getRedirectResult()
    //     .then(function(result) {
    //       if (result.credential) {
    //         // This gives you a Google Access Token. You can use it to access the Google API.
    //         var token = result.credential.accessToken;
    //         this.token = token;
    //         // ...
    //       }
    //       // The signed-in user info.
    //       var user = result.user;
    //       this.user = user;
    //     })
    //     .catch(function(error) {
    //       // Handle Errors here.
    //       var errorCode = error.code;
    //       var errorMessage = error.message;
    //       // The email of the user's account used.
    //       var email = error.email;
    //       // The fb.auth.AuthCredential type that was used.
    //       var credential = error.credential;
    //       alert(`${(errorCode, errorMessage, email, credential)}`);
    //       // ...
    //     });
    // }
  }
};
</script>

<style></style>
